import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { DatabaseTools } from 'src/modules/database/shared/database-tools';
import { Utils } from 'src/modules/utils/shared/utils';
import { FirstLoginComponent } from '../first-login/first-login.component';

@Component({
    selector: 'sm-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent extends ComponentView {

    app = inject(MainAppService);
    router = inject(Router);
    fb = inject(FormBuilder);
    message = inject(MessageService);

    form: FormGroup;
    waiting = false;

    async initParams(): Promise<boolean> {
        this.form = this.fb.group({
            userName: ['', Validators.required],
            password: ['', Validators.required],
            remember: [false]
        });
        return true;
    }

    async send(): Promise<void> {
        let userName = (this.form.get('userName').value as string).trim();
        if (Utils.isNoe(userName)) {
            this.message.add({ severity: 'error', summary: 'Fehler', detail: 'Bitte geben Sie einen Benutzernamen ein' });
            return;
        }
        let password = this.form.get('password').value as string;
        if (Utils.isNoe(password)) {
            this.message.add({ severity: 'error', summary: 'Fehler', detail: 'Bitte geben Sie ein Passwort ein' });
            return;
        }
        this.waiting = true;
        try {
            let resultCode = await this.app.auth.login(userName, password);
            switch (resultCode) {
                case 0:
                    try {
                        await this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl as string || '/');
                    }
                    catch {
                        await this.router.navigateByUrl('/');
                    }
                    break;
                case 1:
                    this.message.add({ severity: 'error', summary: 'Anmeldung fehlgeschlagen', detail: 'Die Kombination aus Benutzername und Passwort ist unbekannt' });
                    break;
                case DatabaseTools.errorIdLoginAnswerQuestions:
                case DatabaseTools.errorIdLoginMustSetPassword:
                    FirstLoginComponent.currentPassword = password;
                    await this.router.navigate(['base', 'firstlogin'], { queryParams: { userName: this.form.get('userName').value }});
                    break;
            }
        }
        finally {
            this.waiting = false;
        }
    }
}
